import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	panelTitle: {
		id: 'software-view-settings.panel-title',
		defaultMessage: 'View settings',
		description: 'Title for panel when view settings is opened in panel view',
	},
});
